import React from 'react';

export const AuthError = ({ message, testId }) => message ? (
  <p role="alert" data-testid={testId} style={{ color: '#b42318', fontSize: 13, lineHeight: 1.5, margin: '8px 0', overflowWrap: 'anywhere' }}>
    {message}
  </p>
) : null;